import React from 'react';
import { PD, SF } from './tokens';

type Tone = 'success' | 'pending' | 'warn' | 'danger' | 'lime' | 'default';
type Size = 'sm' | 'md';

interface StatusPillProps {
  tone?: Tone;
  icon?: string;
  dot?: boolean;
  size?: Size;
  children: React.ReactNode;
}

const TONES: Record<Tone, { bg: string; fg: string }> = {
  default: { bg: PD.fill, fg: PD.ink2 },
  pending: { bg: PD.fill, fg: PD.ink2 },
  success: { bg: PD.successSoft, fg: PD.successInk },
  warn: { bg: PD.warnSoft, fg: PD.warnInk },
  danger: { bg: PD.dangerSoft, fg: PD.dangerInk },
  lime: { bg: PD.limeSoft, fg: PD.limeInk }
};

const SIZES: Record<Size, { fs: number; py: number; px: number; gap: number }> = {
  sm: { fs: 11, py: 2, px: 8, gap: 4 },
  md: { fs: 11.5, py: 3, px: 9, gap: 5 }
};

const StatusPill: React.FC<StatusPillProps> = ({ tone = 'default', icon, dot, size = 'md', children }) => {
  const t = TONES[tone];
  const s = SIZES[size];
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: s.gap,
        padding: `${s.py}px ${s.px}px`,
        borderRadius: 999,
        background: t.bg,
        color: t.fg,
        fontFamily: SF,
        fontSize: s.fs,
        fontWeight: 600,
        whiteSpace: 'nowrap',
        lineHeight: 1
      }}
    >
      {dot && (
        <span
          style={{
            width: 5,
            height: 5,
            borderRadius: '50%',
            background: t.fg,
            opacity: 0.85,
            flex: '0 0 auto'
          }}
        />
      )}
      {icon && <i className={`pi ${icon}`} style={{ fontSize: 11, color: t.fg, lineHeight: 1 }} />}
      {children}
    </span>
  );
};

export default StatusPill;
